// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.product-upload-container {
  width: calc(100% - 80px); /* Adjust width to fit next to the navbar */
  max-width: 550px;
  border-radius: 10px;
  padding: 10px;
  background-color: #f9f9f9; /* Light background for better contrast */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Subtle shadow for a card effect */
  height: auto; /* Auto height for better content fit */
  box-sizing: border-box; /* Ensure padding is included in width calculations */
  margin: 5px auto; /* Center container horizontally */
}

/* Center the heading */
.product-upload-container h1 {
  text-align: center;
  margin-bottom: 20px;
}

/* Form styles */
.upload-form {
  display: flex;
  flex-direction: column;
}

.form-div {
  width: 100%;
  margin-bottom: 15px; /* Increase spacing between fields */
}

.form-input-title,
.form-input-price,
.form-textarea-description,
.form-select-category,
.form-file-input-image,
.form-file-input-pdf {
  width: 100%;
  padding: 10px; /* Increased padding for better input feel */
  border: 1px solid #ccc;
  border-radius: 5px; /* Rounded corners */
  margin-bottom: 15px; /* Increased margin for spacing */
  box-sizing: border-box; /* Ensure padding is included in width calculations */
}

.form-textarea-description {
  height: 100px; /* Adjust height for the textarea */
  resize: vertical; /* Allow vertical resizing */
}

.submit-button {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #0056b3; /* Darker shade for hover effect */
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .product-upload-container {
    width: calc(100% - 40px); /* Adjust width for mobile view */
    margin: 10px; /* Reduce margin for smaller screens */
    padding: 15px; /* Adjust padding for smaller screens */
  }
  
  .form-input-title,
  .form-input-price,
  .form-textarea-description,
  .form-select-category,
  .form-file-input-image,
  .form-file-input-pdf {
    width: 100%; /* Ensure full width for input fields */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin/ProductManagement/UploadProductData/UploadProductData.css"],"names":[],"mappings":";AACA;EACE,wBAAwB,EAAE,2CAA2C;EACrE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB,EAAE,yCAAyC;EACpE,uCAAuC,EAAE,oCAAoC;EAC7E,YAAY,EAAE,uCAAuC;EACrD,sBAAsB,EAAE,qDAAqD;EAC7E,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;;;;;;EAME,WAAW;EACX,aAAa,EAAE,4CAA4C;EAC3D,sBAAsB;EACtB,kBAAkB,EAAE,oBAAoB;EACxC,mBAAmB,EAAE,iCAAiC;EACtD,sBAAsB,EAAE,qDAAqD;AAC/E;;AAEA;EACE,aAAa,EAAE,mCAAmC;EAClD,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA,2BAA2B;AAC3B;EACE;IACE,wBAAwB,EAAE,iCAAiC;IAC3D,YAAY,EAAE,sCAAsC;IACpD,aAAa,EAAE,uCAAuC;EACxD;;EAEA;;;;;;IAME,WAAW,EAAE,uCAAuC;EACtD;AACF","sourcesContent":["\n.product-upload-container {\n  width: calc(100% - 80px); /* Adjust width to fit next to the navbar */\n  max-width: 550px;\n  border-radius: 10px;\n  padding: 10px;\n  background-color: #f9f9f9; /* Light background for better contrast */\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Subtle shadow for a card effect */\n  height: auto; /* Auto height for better content fit */\n  box-sizing: border-box; /* Ensure padding is included in width calculations */\n  margin: 5px auto; /* Center container horizontally */\n}\n\n/* Center the heading */\n.product-upload-container h1 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n/* Form styles */\n.upload-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-div {\n  width: 100%;\n  margin-bottom: 15px; /* Increase spacing between fields */\n}\n\n.form-input-title,\n.form-input-price,\n.form-textarea-description,\n.form-select-category,\n.form-file-input-image,\n.form-file-input-pdf {\n  width: 100%;\n  padding: 10px; /* Increased padding for better input feel */\n  border: 1px solid #ccc;\n  border-radius: 5px; /* Rounded corners */\n  margin-bottom: 15px; /* Increased margin for spacing */\n  box-sizing: border-box; /* Ensure padding is included in width calculations */\n}\n\n.form-textarea-description {\n  height: 100px; /* Adjust height for the textarea */\n  resize: vertical; /* Allow vertical resizing */\n}\n\n.submit-button {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 5px;\n  background-color: #007bff;\n  color: #fff;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.submit-button:hover {\n  background-color: #0056b3; /* Darker shade for hover effect */\n}\n\n/* Responsive adjustments */\n@media screen and (max-width: 768px) {\n  .product-upload-container {\n    width: calc(100% - 40px); /* Adjust width for mobile view */\n    margin: 10px; /* Reduce margin for smaller screens */\n    padding: 15px; /* Adjust padding for smaller screens */\n  }\n  \n  .form-input-title,\n  .form-input-price,\n  .form-textarea-description,\n  .form-select-category,\n  .form-file-input-image,\n  .form-file-input-pdf {\n    width: 100%; /* Ensure full width for input fields */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
